module.exports = __webpack_public_path__ + "img/b34ec9b.jpg";